export enum MapLayerValidationType {
        NotValidated = 0, // unavailable - no pound sign
        ErrorValidating = 1, // unavailable - no pound sign
        Valid = 2,
        NoPermissionForLayer = 3, // area boundary changed or polygon restriction - £
        NoPermissionForArea = 4, // stat access changed - £
        LayerNotInArea = 5, // unavailable - no pound sign
        AssetsNotInArea = 6 // unavailable - no pound sign
}